<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li>
            <router-link to="/inventory/items" class="">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h3>
              <td>{{ $t("setup.label.ViewItem") }}</td>
            </h3>
          </li>
        </ul>
      </div>
      <div class="vx-col md:w-full lg:w-full sm:w-full w-full mb-base">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-edit-2"
                      class="truncate"
                      @click="editData()"
                      size="small"
                      >{{ $t("setup.label.Edit") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="vx-row">
            <div class="w-full">
              <div class="block overflow-x-auto">
                <table class="table w-full table-bordered table-striped">
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.ItemCode") }}</b>
                    </td>
                    <td>{{ viewitem.itemCode }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.ItemDescription") }}</b>
                    </td>
                    <td>{{ viewitem.itemDescription }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.ChargeCode") }}</b>
                    </td>
                    <td>{{ viewitem.chargeCode }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.ItemClass") }}</b>
                    </td>
                    <td>{{ viewitem.itemClassName }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.Units") }}</b>
                    </td>
                    <td>{{ viewitem.units }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.UnitPrice") }}</b>
                    </td>
                    <td>{{ viewitem.unitPrice }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.Warranty") }}</b>
                    </td>
                    <td>{{ viewitem.warranty }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.IsProvisioning") }}</b>
                    </td>
                    <td>{{ viewitem.isProvisioning }}</td>
                  </tr>
                  <tr>
                    <td class="border-none">
                      <b>{{ $t("setup.label.Currency") }} </b>
                    </td>
                    <td class="border-none">{{ viewitem.name }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="w-full">
              <div class="block overflow-x-auto">
                <table class="table w-full table-bordered table-striped">
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.Id") }}</b>
                    </td>
                    <td>
                      <b>{{ $t("setup.label.ItemMasterId") }}</b>
                    </td>
                    <td>
                      <b>{{ $t("setup.label.RegionId") }}</b>
                    </td>
                    <td>
                      <b>{{ $t("setup.label.Price") }}</b>
                    </td>
                  </tr>

                  <tr
                    v-for="(item, index) in viewitem.itemPricesDatas"
                    :key="index"
                  >
                    <td>{{ item.id }}</td>
                    <td>{{ item.itemMasterId }}</td>
                    <td>{{ item.regionId }}</td>
                    <td>{{ item.price }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <delete-popup
      :deletePopup="deleteitemPopup"
      :title="$t('inventory.label.Item')"
      @deletePressed="deleteitem()"
      @cancelPressed="deleteitemPopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import moment from "moment";
import vSelect from "vue-select";
import { mapState } from "vuex";
export default {
  data() {
    return {
      id: "",
      viewitem: {},
      editJobsPopup: false,
      delId: 0,
      redirectToEdit: false,
      deleteitemPopup: false,
      updateCraditPopup: false,
      jobsParameterPopup: false,
    };
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      item: (state) => state.items.itemIdTemplate,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    getDate(date) {
      return moment(date).format(this.formattedDate);
    },
    editData() {
      this.$router.push({ name: "Edit Item", params: { id: this.id } });
    },

    async getitemById() {
      try {
        await this.$store.dispatch("items/setItemTemplateById", this.id);
        this.viewitem = this.item;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getitemById();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
